import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-email",
  "use": "svg-icon-email-usage",
  "viewBox": "0 0 14 17",
  "content": "<symbol viewBox=\"0 0 14 17\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-email\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M1.064 7.143l5.684 4.738 5.685-4.737M.787 6.653v9h4.185c.918-.02 7.737 0 7.737 0v-9m-.05-.14l-5.912-4.88-5.91 4.88\" stroke=\"#717B7F\" stroke-width=\"1.5\" /><path d=\"M6.748 11.88L3.796 9.423v-6.63H9.7v6.63\" /><path stroke=\"#717B7F\" stroke-width=\"1.5\" d=\"M6.748 11.88L3.796 9.423v-6.63H9.7v6.63z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol